import { List } from '@mui/material';
import Typography from '@mui/material/Typography';
import AccordionItem from '@src/main/ui/components/AreasMenu/AccordionItem/AccordionItem';
import ListItem from '@src/main/ui/components/AreasMenu/ListItem/ListItem';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import useNavbarItems, {
  NavbarItems,
} from '@src/main/ui/components/layout/common/Navbar/common/hooks/useNavbarItems';
import { type FC } from 'react';
import styles from './AreasMenu.module.scss';

const AreasMenu: FC = () => {
  const navbarItems: NavbarItems | undefined = useNavbarItems();
  return (
    <>
      <div className={styles.header}>
        <Typography variant="h4">Areas</Typography>
      </div>
      {navbarItems &&
        navbarItems.areas.map((area) => (
          <AccordionItem
            key={area.text}
            title={
              <>
                {area.icon && <Icon fontSize="20px" iconId={area.icon} />}
                <Typography
                  sx={{
                    ml: 2,
                  }}
                >
                  {area.text}
                </Typography>
              </>
            }
            body={
              <List>
                {(area?.menuItems || []).map((menuItem) => (
                  <ListItem {...menuItem} key={menuItem.text} />
                ))}
              </List>
            }
          />
        ))}
    </>
  );
};

export default AreasMenu;
